module.exports = __webpack_public_path__ + "static/media/carousel_03.cd7c2e2f.gif";